"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.f7885 = void 0;
exports.f7885 = {
    "ọhọ̀rí": [
        3174
    ],
    "ọḍual": [
        5843
    ],
    "ọgba": [
        5849
    ]
};
